const ROUND = 'stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"';

export const POUSSIN_MARK =
  `<path d="M18.4 7.4a4.6 4.6 0 0 0-8.7 1.9c-3.4.5-6.2 3.2-6.2 6.5 0 3.6 3.3 6.2 7.6 6.2 4.6 0 8-2.9 8-6.8 0-1.7-.6-3.1-1.6-4.2.5-.5.8-1.1.9-1.8" fill="none" ${ROUND} stroke-width="2"/>` +
  '<path d="m18.6 7.1 4 1.5-4 1.5z" fill="currentColor"/>' +
  '<circle cx="15.4" cy="7.6" r="1.2" fill="currentColor"/>' +
  `<path d="M7.6 15.4c1.4 1.6 3.4 2 5.2 1.2M13.2 4.6c-.2-1.4.5-2.4 1.6-2.6" fill="none" ${ROUND} stroke-width="1.6"/>`;

export const DEBANDADE_ICON =
  '<circle cx="11.5" cy="5.6" r="3.1" fill="currentColor"/>' +
  '<circle cx="14.7" cy="4.3" r="2.1" fill="currentColor"/>' +
  '<path d="M16.5 3.6l2.4.7-2.4.7z" fill="currentColor"/>' +
  '<circle cx="14.5" cy="12.6" r="3.1" fill="currentColor"/>' +
  '<circle cx="17.7" cy="11.3" r="2.1" fill="currentColor"/>' +
  '<path d="M19.5 10.6l2.4.7-2.4.7z" fill="currentColor"/>' +
  '<circle cx="11.5" cy="19.6" r="3.1" fill="currentColor"/>' +
  '<circle cx="14.7" cy="18.3" r="2.1" fill="currentColor"/>' +
  '<path d="M16.5 17.6l2.4.7-2.4.7z" fill="currentColor"/>' +
  `<path d="M2.5 5.6h3.4 M5.5 12.6h3.4 M2.5 19.6h3.4" fill="none" ${ROUND} stroke-width="1.8"/>`;
